/* eslint-disable no-else-return */
/* eslint-disable no-else-return */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable radix */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-use-before-define */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
// React and React Router modules
/* eslint-disable import/no-unresolved */
import React, {
  useEffect, useState, useContext, useRef,
} from 'react';
// Material UI Components and styles
import {
  Grid, Typography, Button, Popover, Backdrop, Modal, Fade, IconButton,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

// Api Functions and Context for data
import { Close } from '@material-ui/icons';

import Cookies from 'js-cookie';
import { StreamSegmentContext } from '@services/context/CoinsContext';

// Router last location
import { useLastLocation } from 'react-router-last-location';

// third party packages and libraries
import Swal from 'sweetalert2';

// assets for kumu live video stream feature
import addimage from '@assets/images/kumu-logo-add.png';
import openSlot from '@assets/images/livestream/audio/Co-Hosting-open.png';
import lockSlot from '@assets/images/livestream/audio/Co-Hosting-lock.png';
import diamond from '@assets/images/livestream/diamond.png';
// social media assets
import messenger from '@assets/images/social-media-icons/messenger.png';
import whatsapp from '@assets/images/social-media-icons/whatsapp.png';
import facebook from '@assets/images/social-media-icons/share-facebook.png';

// loadable components
import loadable from '@loadable/component';

import {
  getVideoSlots, getAudioSlots, getLiveStreamRegular, getUser, getUserInfo,
} from '@shared/services/userApi';
import { UserContext } from '@context/UserContext';

import NumberFormatter from '@shared/utils/NumberFormatter';
import LoadingIndicator from '@shared/components/LoadingIndicator/LoadingIndicator';
import useFacebookSdk from '@shared/hooks/useFacebookSdk';

// styles
import './VideoStream.css';
import { streamLayouts } from '../data/streamLayouts.json';

// Video Layouts Components
const OneSlot = loadable(() => import('../components/OneSlot/OneSlot'));
const TwoSlots = loadable(() => import('../components/TwoSlots/TwoSlots'));
const FourSlots = loadable(() => import('../components/FourSlots/FourSlots'));
const FirstSixSlots = loadable(() => import('../components/FirstSixSlots/FirstSixSlots'));
const SecondSixSlots = loadable(() => import('../components/SecondSixSlots/SecondSixSlots'));
const NineSlots = loadable(() => import('../components/NineSlots/NineSlots'));
const VideoStreamEnded = loadable(() => import('../components/VideoStreamEnded/VideoStreamEnded'));
const AudioStream = loadable(() => import('../components/AudioStream/AudioStream'));

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '10px',
    width: '100%',
    boxShadow: theme.shadows[5],
    color: '#000',
    [theme.breakpoints.down('sm')]: {
      height: '340px',
      maxWidth: '350px',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '500px',
      height: '280px',
    },
  },
  paperSm: {
    height: '350px',
    maxWidth: '350px',
  },
  modal: {
    zIndex: '9999',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function VideoStream({
  channelId, _test, video, type, relation_status, ...props
}) {
  // intialize facebook sdk hooks
  useFacebookSdk();
  // Initialize the logged in context
  const { loggedIn } = useContext(UserContext);

  // Initialize Coins Segment Context
  const { setSegmentCoinsContext } = useContext(StreamSegmentContext);

  // Video stream states
  const [userData, setUserData] = useState([]);
  const [slotsTotal, setSlotsTotal] = useState('');
  const [muteState, setMuteState] = useState(false);
  const [volume, setVolume] = useState(50);
  const [lastVolume, setLastVolume] = useState(0);
  const [remoteUsersObject, setRemoteUsersObject] = useState([]);
  const [coverImage, setCoverImage] = useState('');
  const [campaignId, setCampaignId] = useState('');
  const [title, setTitle] = useState('');
  const [, setCohost] = useState([]);
  const [isLiveStreamEnded, setIsLiveStreamEnded] = useState(false);
  const [landscape, setLandscape] = useState('0');
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [loadingStream, setLoadingStream] = useState(false);
  const [rtmp, setRtmp] = useState('0');

  // ------------------ Functions for Starting the streams --------------------

  // render the locked and unlocked image
  const addSlotBackground = (object, cohostContainer) => {
    if (object.locked === 1) {
      cohostContainer.classList.add('temp-video-view-locked');
    } else {
      cohostContainer.classList.add('temp-video-view-add');
    }
  };

  const videoSlotLoop = (videoSlotsData) => {
    for (const object of videoSlotsData) {
      const cohostContainer = document.getElementsByClassName(`content-${object.slot_number}`)[0];
      addSlotBackground(object, cohostContainer);
    }
  };

  const getVideoSlotsHelper = async (videoSlotsData, stream_id) => {
    if (video !== '1' || video !== '2') {
      await getVideoSlots(stream_id).then((response) => {
        if (response.status === 200 && response.data.code === '200') {
          videoSlotsData = response.data.data.slots;
          if (videoSlotsData) {
            videoSlotLoop(videoSlotsData);
          }
        }
      });
      return {
        video_slots_object: videoSlotsData,
      };
    }
  };

  // audio slots set up
  const audioSlotUpdate = (videoSlotsData) => {
    let perSlot = 0; // slot class
    let perGrid = 0; // grid class
    for (let index = 1; index < videoSlotsData.length + 1; index++) {
      if (index === 1 || index === 4 || index === 7 || index === 10) {
        perGrid++;
      }
      if (index % 3 === 1) {
        perSlot = 0;
      } else {
        perSlot++;
      }
      const slot = document.getElementsByClassName(
        `slotImage-${perGrid - 1}-${perSlot}`,
      )[0];
      const userUsername = document.getElementsByClassName(
        `username-${perGrid - 1}-${perSlot}`,
      )[0];
      const userDiamond = document.getElementsByClassName(
        `diamond-${perGrid - 1}-${perSlot}`,
      )[0];
      const audioIconMute = document.getElementsByClassName(
        `audio-muted-${perGrid - 1}-${perSlot}`,
      )[0];
      const audioIcon = document.getElementsByClassName(
        `audio-${perGrid - 1}-${perSlot}`,
      )[0];
      if (videoSlotsData[index - 1].hasOwnProperty('user')) {
        audioUserSlot(
          videoSlotsData,
          index,
          slot,
          userUsername,
          userDiamond,
          audioIcon,
          audioIconMute,
        );
      } else {
        userUsername.innerHTML = '';
        userDiamond.innerHTML = '';
        audioIcon.style.display = 'none';
        audioIconMute.style.display = 'none';

        if (videoSlotsData[index - 1].locked === 1) {
          slot.src = lockSlot;
          slot.style.display = 'block';
        } else {
          slot.src = openSlot;
          slot.style.display = 'block';
        }
      }
    } // end for
  };
  // get the video slots data to determine the latest slots activities and status
  const getVideoSlotsData = async (stream_id) => {
    let videoSlotsData = [];

    if (video === '3') { // Audio slots
      await getAudioSlots(stream_id).then((response) => {
        if (response.data.code === '200'
        && response.data.status === 'success') {
          videoSlotsData = response.data.data.slots;
          if (videoSlotsData.length > 0) {
            audioSlotUpdate(videoSlotsData);
          } // end if
        }
      });
      return {
        video_slots_object: videoSlotsData,
      };
    }
    return getVideoSlotsHelper(videoSlotsData, stream_id);
  };

  const audioUserSlot = (
    videoSlotsData,
    index,
    slot,
    userUsername,
    userDiamond,
    audioIcon,
    audioIconMute,
  ) => {
    slot.src = videoSlotsData[index - 1].user.avatar_small;
    slot.style.display = 'block';

    const textUsername = document.createTextNode(videoSlotsData[index - 1].user.username);
    userUsername.innerHTML = '';
    userUsername.appendChild(textUsername);
    userUsername.style.display = 'block';

    const textDiamond = document.createTextNode(NumberFormatter(
      videoSlotsData[index - 1].user.diamond,
      1,
    ));
    const imageElement = document.createElement('img');
    imageElement.src = diamond;
    imageElement.setAttribute('alt', 'diamond');
    imageElement.setAttribute('width', '12');
    imageElement.setAttribute('height', '8');
    imageElement.style.marginRight = '3px';
    userDiamond.innerHTML = '';
    userDiamond.appendChild(imageElement);
    userDiamond.appendChild(textDiamond);
    userDiamond.style.display = 'block';

    if (videoSlotsData[index - 1].user.mute_by_self === 1
      || videoSlotsData[index - 1].user.mute_by_host === 1) {
      audioIcon.style.display = 'none';
      audioIconMute.style.display = 'block';
    } else {
      audioIcon.style.display = 'block';
      audioIconMute.style.display = 'none';
    }
  };

  // get all the live stream details of the streamer
  const getUserLivestream = async (stream_id) => {
    setLoadingStream(true);
    let channel_key = '';
    let channel_id = '';
    let liveuser_id = '';
    let avatar = '';
    let stream_slots = [];
    let slotsTotalNum = '';
    let responseObj = [];
    let coverImageData = '';
    // get the live stream based on the channel id
    await getLiveStreamRegular(stream_id).then(async (response) => {
      if (response.status === 200 && response.data.code === '200') {
        setLandscape(response.data.data.landscape);
        setSlotsTotal(response.data.data.video);
        setRtmp(response.data.data.rtmp);
        channel_key = response.data.data.channel_key;
        channel_id = response.data.data.channel_id;
        stream_slots = response.data.data.slots;
        liveuser_id = response.data.data.liveuser.id;
        avatar = response.data.data.liveuser.avatar;
        slotsTotalNum = response.data.data.video;
        responseObj = response;
        setCoverImage(response.data.data.cover_image);
        setLoadingStream(false);
        setCampaignId(response.data.data.campaign_id);
        setTitle(response.data.data.title);

        coverImageData = response.data.data.cover_image;
      }
    });
    // return all the data in an object form once api done from calling
    return {
      channelKey: channel_key,
      channelIdVal: channel_id,
      stream_slots,
      host_uid: liveuser_id,
      avatar,
      slotsTotalNum,
      agoraAppId: process.env.REACT_APP_AGORA_APP_ID,
      response_data: responseObj,
      cover_image: coverImageData,
    };
  };
  // another live stream api call specifically for profile related components
  const getUserSpecificLivestream = async (stream_id) => {
    getLiveStreamRegular(stream_id).then((response) => {
      if (response.status === 200 && response.data.code === '200') {
        setUserData(response.data.data.liveuser);
      }
    });
  };

  useEffect(() => {
    getUserSpecificLivestream(channelId);
  }, [channelId]);

  const getUserData = async (uid) => {
    let objectData = [];
    await getUser(null, uid).then((response) => {
      objectData = response.data.data;
    });
    return {
      host_data: objectData,
    };
  };

  const getUserInfoData = async (uid, channelIdVal) => {
    let responseData = [];
    let userId = '';
    await getUserInfo(uid, channelIdVal).then((response) => {
      responseData = response.data.data;
      userId = uid;
    });
    return {
      user_data: responseData,
      uid: userId,
    };
  };

  // Main Helper function for adding Background image of various slot layouts
  const addingBackgroundHandler = async (
    uid,
    videoContainer,
    mainContainer,
    isPublishing,
    single,
  ) => {
    // get user data
    const hostData = await getUserData(uid);
    // creating new elements of image and name
    // initializing the profile container
    const imageElement = document.createElement('img');
    const nameElement = document.createElement('p');
    const profileContainer = document.createElement('div');

    // image component attributes and source
    imageElement.src = hostData.host_data.avatar;
    imageElement.style.borderRadius = '50%';
    imageElement.setAttribute('width', '12vw');
    imageElement.setAttribute('height', '12vh');
    imageElement.setAttribute('id', `avatar-${hostData.host_data.user_id}`);
    // name component
    nameElement.innerText = hostData.host_data.username;
    nameElement.classList.add('username-style');
    nameElement.setAttribute('id', `username-${hostData.host_data.user_id}`);

    // get the existing profilecontainer
    const existingProfileContainer = document.getElementById(`profile-${uid}`);

    // add profile container for name and avatar for each video slots
    profileContainer.classList.add('profile-container-video');
    profileContainer.id = `profile-${uid}`;
    profileContainer.appendChild(imageElement);
    profileContainer.appendChild(nameElement);
    // check if for publishing of video stream, return background image none if video is on
    // else render the avatar as background image
    if (isPublishing === true) {
      videoContainer.style.backgroundImage = 'none';
      videoContainer.id = uid.toString();
      if (existingProfileContainer) {
        videoContainer.replaceChild(profileContainer, existingProfileContainer);
      } else if (hostData.host_data.username) {
        videoContainer.appendChild(profileContainer);
      }
    } else if (isPublishing === false) {
      if (existingProfileContainer) {
        videoContainer.replaceChild(profileContainer, existingProfileContainer);
      } else {
        videoContainer.appendChild(profileContainer);
      }
      videoContainer.style.backgroundImage = `url(${hostData.host_data.avatar})`;
      videoContainer.style.backgroundSize = 'cover';
      videoContainer.style.backgroundPosition = 'center';
      videoContainer.style.backgroundRepeat = 'no-repeat';
      videoContainer.classList.add('video-container');
      videoContainer.id = uid.toString();
    }
    // this is for new joined hosts who doesn't have any video when audience enter the channel,
    // it will render their avatar as background by default
    if (mainContainer !== null && mainContainer !== undefined) {
      if (single === false) {
        videoContainer.textContent = '';
      }
      videoContainer.style.visibility = 'visible';
      videoContainer.classList.add('cohost-container-default');
      mainContainer.style.display = 'flex';
      mainContainer.appendChild(videoContainer);
    }
    return videoContainer;
  };

  // ** ------------- All main and helper functions for
  // adding and removing background image and container elements -------- //
  /// GET CONTAINER ELEMENT FOR MAIN HOST
  const getElementContainerHost = async (remoteUserId, userInfo) => {
    const remoteUserContainer = document.getElementsByClassName('content-0')[0];
    const imageElementSpot = document.createElement('img');
    const nameElementSpot = document.createElement('p');
    const profileContainer = document.createElement('div');
    if (userInfo?.user_data.live_in_spotlight === 1) {
      // image component attributes and source
      imageElementSpot.src = userInfo.user_data.avatar;
      imageElementSpot.style.borderRadius = '50%';
      imageElementSpot.setAttribute('width', '12vw');
      imageElementSpot.setAttribute('height', '12vh');
      imageElementSpot.setAttribute('id', `avatar-${remoteUserId}`);
      // name component
      nameElementSpot.innerText = userInfo.user_data.username;
      nameElementSpot.classList.add('username-style');
      nameElementSpot.setAttribute('id', `username-${remoteUserId}`);

      profileContainer.classList.add('profile-container-video');
      profileContainer.id = `profile-${remoteUserId}`;
      profileContainer.appendChild(imageElementSpot);
      profileContainer.appendChild(nameElementSpot);

      remoteUserContainer.appendChild(profileContainer);
    }
    remoteUserContainer.style.backgroundImage = 'none';
    remoteUserContainer.id = remoteUserId;
    if (userInfo?.user_data.live_in_spotlight === '') {
      remoteUserContainer.textContent = '';
    }
    return remoteUserContainer;
  };
  // GET ELEMENT FOR CO HOST WITH MULTI VIDEO SLOTS
  const getElementCoHost = async (remoteUsers, videoSlotsObject) => {
    if (videoSlotsObject) {
      for (const object of videoSlotsObject.video_slots_object) {
        if (object.hasOwnProperty('user')) {
          if (object.user.uid === remoteUsers.uid) {
            const cohostContainer = document.getElementsByClassName(
              `content-${object.slot_number}`,
            )[0];
            cohostContainer.classList.remove('temp-video-view-add');
            return addingBackgroundHandler(object.user.uid, cohostContainer, null, true, false);
          }
        }
      }
    }
  };
  // GET ALL VIDEO ELEMENT FOR CO HOST IN A SINGLE PLAYER STREAM
  const getSingleWithCoHostElement = async (coHosts, remoteUsers) => {
    for (const [, object] of coHosts.entries()) {
      if (object.uid === remoteUsers.uid) {
        const checkExistingVideoContainer = document.getElementById(`${object.uid.toString()}`);
        if (checkExistingVideoContainer) {
          return addingBackgroundHandler(
            object.uid,
            checkExistingVideoContainer,
            null,
            true,
            false,
          );
        }
        const cohostMainContainer = document.getElementsByClassName('cohost-container')[0];
        cohostMainContainer.style.display = 'flex';
        const cohostContainer = document.createElement('div');
        return addingBackgroundHandler(
          object.uid,
          cohostContainer,
          cohostMainContainer,
          true,
          true,
        );
      }
    }
  };

  //* * REMOVING BACKGROUND MAIN FUNCTIONS AND HELPER FUNCTIONS -------------------  */
  // helper function for removing background image of co host video slots when left in the stream
  const removeBackgroundHelperCoHost = async (remoteUsers, videoSlotsObject) => {
    for (const object of videoSlotsObject.video_slots_object) {
      if (object.hasOwnProperty('user')) {
        if (object.user.uid === remoteUsers.uid) {
          const cohostContainer = document.getElementById(`${object.user.uid}`);
          if (cohostContainer) {
            cohostContainer.removeAttribute('id');
            cohostContainer.style.backgroundImage = `url(${addimage})`;
            cohostContainer.style.backgroundRepeat = 'no-repeat';
            cohostContainer.style.backgroundSize = '25%';
            cohostContainer.style.backgroundPosition = 'center';
            const profileContainer = document.getElementById(`profile-${object.user.uid}`);
            if (profileContainer) {
              profileContainer.remove();
            }
          }
        }
      }
    }
  };
  // Main function for removing background image of main host and cohost video stream
  const removeAvatarBackground = async (remoteUsers, optionsData, videoSlotsObject) => {
    if (remoteUsers.uid === optionsData.host_uid) {
      const remoteUserContainer = document.getElementsByClassName(
        'content-0',
      )[0];
      remoteUserContainer.style.backgroundImage = 'none';
    } else if (videoSlotsObject.video_slots_object) {
      removeBackgroundHelperCoHost(remoteUsers, videoSlotsObject);
    }
  };
  // helper function for removing video container element of co host from single player stream
  const removeCoHostSingle = async (coHosts, remoteUsers) => {
    for (const [, object] of coHosts.entries()) {
      if (object.uid === remoteUsers.uid) {
        const containerCoHost = document.getElementById(`${object.uid.toString()}`);
        containerCoHost && containerCoHost.remove();
      }
    }
  };

  const removeAvatarCoHostMultiSlot = async (optionsData, remoteUsers, coHosts, videoSlots) => {
    if (remoteUsers.uid !== optionsData.host_uid) {
      if (coHosts?.length > 0) {
        await removeAvatarBackground(remoteUsers, optionsData, videoSlots);
        coHosts = coHosts.filter((prev) => prev.uid !== remoteUsers.uid);
        return coHosts;
      }
    }
  };

  // Main function for removing the cohost
  // video container element for both single stream and multi host stream
  const removeCohostContainerHelper = async (coHosts, remoteUsers) => {
    if (coHosts?.length > 0) {
      await removeCoHostSingle(coHosts, remoteUsers);
      coHosts = coHosts.filter((prev) => prev.uid !== remoteUsers.uid);
      return coHosts;
    }
  };
  const removeCohostContainer = async (
    optionsData,
    remoteUsers,
    coHosts,
    videoSlots,
    spotlightHosts,
  ) => {
    if (remoteUsers.uid === optionsData.host_uid) {
      setIsLiveStreamEnded(true);
      props.endStream();
    } else if (optionsData.slotsTotalNum === '1' || optionsData.slotsTotalNum === '2') {
      if (remoteUsers.uid !== optionsData.host_uid) {
        const userIdObject = spotlightHosts.find((id) => id === remoteUsers.uid);
        if (userIdObject) {
          spotlightHosts = spotlightHosts.filter((id) => id !== remoteUsers.uid);
          const remoteUserContainer = document.getElementsByClassName('content-0')[0];
          remoteUserContainer.style.backgroundImage = `url(${optionsData.cover_image})`;
          remoteUserContainer.style.backgroundSize = 'cover';
          remoteUserContainer.style.backgroundRepeat = 'no-repeat';
          remoteUserContainer.style.backgroundPosition = 'center';
          remoteUserContainer.textContent = '';
          return {
            spotlightHosts,
            spotlightVal: true,
          };
        }
        return removeCohostContainerHelper(coHosts, remoteUsers);
      }
    } else if (optionsData.slotsTotalNum !== '1' || optionsData.slotsTotalNum !== '2') {
      return removeAvatarCoHostMultiSlot(optionsData, remoteUsers, coHosts, videoSlots);
    } else {
      await removeAvatarBackground(remoteUsers, optionsData, videoSlots);
    }
  };

  const livestreamEndedAudio = async (remoteUsers, optionsData) => {
    if (remoteUsers.uid === optionsData.host_uid && video === '3') {
      setIsLiveStreamEnded(true);
      props.endStream();
    }
  };

  //* * ADDING BACKGROUND IMAGE FOR HOST AND CO HOSTS -------------------  */
  // Helper function for adding background image for cohost of multi host video stream
  const addBackgroundHelperCoHost = async (remoteUsers, _optionsData, videoSlotsObject) => {
    for (const object of videoSlotsObject.video_slots_object) {
      if (object.hasOwnProperty('user')) {
        if (object.user.uid === remoteUsers.uid) {
          const cohostContainer = document.getElementsByClassName(
            `content-${object.slot_number}`,
          )[0];
          await addingBackgroundHandler(
            object.user.uid,
            cohostContainer,
            null,
            false,
            false,
          );
        } else {
          const cohostContainerNonRemote = document.getElementsByClassName(
            `content-${object.slot_number}`,
          )[0];
          await addingBackgroundHandler(
            object.user.uid,
            cohostContainerNonRemote,
            null,
            false,
            false,
          );
        }
      }
    }
  };
  // helper function for adding background image for cohost of a single player stream
  const addBackgroundHelperCoHostSingle = async (remoteUsers, coHosts) => {
    for (const [, object] of coHosts.entries()) {
      if (object.uid === remoteUsers.uid) {
        const getExistingVideoContainer = document.getElementById(`${object.uid.toString()}`);
        if (getExistingVideoContainer) {
          await addingBackgroundHandler(object.uid, getExistingVideoContainer, null, false, true);
        } else {
          const mainContainer = document.getElementsByClassName('cohost-container')[0];
          const newContainer = document.createElement('div');
          await addingBackgroundHandler(object.uid, newContainer, mainContainer, false, true);
        }
      }
    }
  };
  const addImageCover = async (optionsData, remoteUserContainer) => {
    if (optionsData.slotsTotalNum === '1'
    || optionsData.slotsTotalNum === '2') {
      remoteUserContainer.style.backgroundImage = `url(${optionsData.cover_image})`;
      remoteUserContainer.style.backgroundSize = 'contain';
    } else {
      remoteUserContainer.style.backgroundImage = `url(${optionsData.avatar})`;
      remoteUserContainer.style.backgroundSize = 'cover';
    }
  };
  // Main Function for adding background of host and cohost for different livestream mode
  const addAvatarBackground = async (
    remoteUsers,
    optionsData,
    videoSlotsObject,
    coHosts,
    userInfo,
  ) => {
    if (remoteUsers.uid === optionsData.host_uid) {
      const remoteUserContainer = document.getElementsByClassName('content-0')[0];
      if (remoteUserContainer) {
        await addImageCover(optionsData, remoteUserContainer);
        remoteUserContainer.style.backgroundRepeat = 'no-repeat';
        remoteUserContainer.id = remoteUsers.uid.toString();
        remoteUserContainer.style.backgroundPosition = 'center';
        remoteUserContainer.textContent = '';
      }
    } else if (userInfo?.user_data.live_in_spotlight === 1) {
      const remoteUserContainerSpot = document.getElementsByClassName('content-0')[0];
      if (remoteUserContainerSpot) {
        remoteUserContainerSpot.style.backgroundImage = `url(${userInfo.user_data.avatar})`;
        remoteUserContainerSpot.style.backgroundSize = 'cover';
        remoteUserContainerSpot.style.backgroundRepeat = 'no-repeat';
        remoteUserContainerSpot.id = remoteUsers.uid.toString();
        remoteUserContainerSpot.style.backgroundPosition = 'center';
        remoteUserContainerSpot.textContent = '';
      }
    } else if (videoSlotsObject.video_slots_object.length > 0) {
      await addBackgroundHelperCoHost(remoteUsers, optionsData, videoSlotsObject);
    } else if (coHosts) {
      await addBackgroundHelperCoHostSingle(remoteUsers, coHosts);
    }
  };
  // helper function for adding background image on
  // hosts who doesn't have video when user enter the stream
  const addUserJoinedBackground = async (
    remoteUsers,
    optionsData,
    videoSlotsObject,
    coHosts,
    userInfo,
    spotlightHosts,
  ) => {
    if (userInfo?.user_data.live_in_spotlight === 1) {
      spotlightHosts.push(userInfo.uid);
    } else if (remoteUsers.uid !== optionsData.host_uid) {
      coHosts.push(remoteUsers);
    }
    // check if host has video when audience enter the stream
    if (remoteUsers.hasVideo === false && video !== '3') {
      await addAvatarBackground(remoteUsers, optionsData, videoSlotsObject, coHosts, userInfo);
    }
  };

  // ** STREAM FUNCTIONS AND CONTROLLERS FOR VARIOUS STREAM MODES **//
  // checking mute status of video stream
  const checkingMuteStream = async (remoteAudioTrack) => {
    const muteValue = Cookies.get('muteState');
    if (muteValue === 'true') {
      remoteAudioTrack.setVolume(0);
    } else {
      remoteAudioTrack.setVolume(volume);
    }
  };

  const coHostPublishHelper = async (userInfo, remoteUsers, coHosts, optionsData) => {
    if (optionsData.slotsTotalNum === '1' || optionsData.slotsTotalNum === '2') {
      if (userInfo.user_data.live_in_spotlight === 1) {
        const remoteVideoTrackCoHost = remoteUsers.videoTrack;
        const remoteUserContainer = await getElementContainerHost(
          remoteUsers.uid.toString(),
          userInfo,
        );
        remoteVideoTrackCoHost.play(remoteUserContainer);
      } else if (userInfo.user_data.live_in_spotlight === '') {
        const remoteVideoTrackCoHost = remoteUsers.videoTrack;
        const cohostContainerElement = await getSingleWithCoHostElement(coHosts, remoteUsers);
        remoteVideoTrackCoHost.play(cohostContainerElement);
      }
    } else {
      const remoteVideoTrackCoHostMulti = remoteUsers.videoTrack;
      const cohostContainerElementMulti = await getSingleWithCoHostElement(coHosts, remoteUsers);
      remoteVideoTrackCoHostMulti.play(cohostContainerElementMulti);
    }
  };
  const playCoHostContainer = async (remoteVideoTrack, cohostContainer) => {
    try {
      if (remoteVideoTrack.isPlaying === false) {
        remoteVideoTrack.play(cohostContainer);
        const videoPlayer = cohostContainer.getElementsByClassName('agora_video_player');
        if (videoPlayer.item(0).paused) {
          videoPlayer.item(0).play();
        }
      }
      // eslint-disable-next-line no-empty
    } catch (error) {}
  };
  const publishCohostStream = async (videoSlotsObjectInside, remoteUsers, remoteVideoTrack) => {
    for (const object of videoSlotsObjectInside.video_slots_object) {
      if (object.hasOwnProperty('user')) {
        if (object.user.uid === remoteUsers.uid) {
          if (object.user.video_mute_by_host === 0 && object.user.video_mute_by_self === 0) {
            const cohostContainer = await getElementCoHost(remoteUsers, videoSlotsObjectInside);
            await playCoHostContainer(remoteVideoTrack, cohostContainer);
            remoteVideoTrack.play(cohostContainer);
          }
        }
      }
    }
  };
  const publishHostStreamHelper = async (remoteUsers) => {
    const remoteVideoTrack = remoteUsers.videoTrack;
    const remoteUserContainer = await getElementContainerHost(remoteUsers.uid.toString(), null);
    try {
      if (remoteVideoTrack.isPlaying === false) {
        remoteVideoTrack.play(remoteUserContainer);
        const videoPlayer = remoteUserContainer.getElementsByClassName('agora_video_player');
        if (videoPlayer.item(0).paused) {
          videoPlayer.item(0).play();
        }
      }
    // eslint-disable-next-line no-empty
    } catch (error) {}
    remoteVideoTrack.play(remoteUserContainer);
  };
  // helper function to handle the stream publish
  const publishStream = async (
    mediaType,
    remoteUsers,
    videoSlotsObjectInside,
    optionsData,
    coHosts,
    userInfo,
    client,
  ) => {
    await client.subscribe(remoteUsers, mediaType);
    if (mediaType === 'video') {
      if (remoteUsers.uid === optionsData.host_uid) {
        await publishHostStreamHelper(remoteUsers);
      } else if (videoSlotsObjectInside.video_slots_object.length > 0) {
        const remoteVideoTrack = remoteUsers.videoTrack;
        await publishCohostStream(videoSlotsObjectInside, remoteUsers, remoteVideoTrack);
      } else {
        coHostPublishHelper(userInfo, remoteUsers, coHosts, optionsData);
      }
    }
    if (mediaType === 'audio') {
      if (remoteUsers.uid === optionsData.host_uid) {
        const remoteAudioTrack = remoteUsers.audioTrack;
        await checkingMuteStream(remoteAudioTrack);
        setRemoteUsersObject((prev) => [...prev, {
          uid: remoteUsers.uid,
          remoteAudioTrack,
        }]);
        remoteAudioTrack.play();
      } else {
        const remoteAudioTrackCohost = remoteUsers.audioTrack;
        await checkingMuteStream(remoteAudioTrackCohost);
        setRemoteUsersObject((prev) => [...prev, {
          uid: remoteUsers.uid,
          remoteAudioTrack: remoteAudioTrackCohost,
        }]);
        remoteAudioTrackCohost.play();
      }
    }
  };

  const startStream = async (client) => {
    await startBasicLiveStreaming(client);
  };

  const [showMuteBtn, setShowMuteBtn] = useState(false);
  const resumeAudioContext = () => {
    setShowMuteBtn(false);
    unmute();
    const audioCtx = new AudioContext();
    if (audioCtx.state === 'suspended') {
      audioCtx.resume();
    }
  };

  const lastLocation = useLastLocation();
  function navigationType() {
    let result = '';
    let p;
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (window.performance.getEntriesByType('navigation')) {
        p = window.performance.getEntriesByType('navigation')[0].type;
        if (p === 'back_forward') { result = document.referrer; }
        if (p === 'navigate') { result = document.referrer; }
        if (p === 'reload') { result = ''; }
      }
      return result;
    }
  }
  function sourceTracker() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (lastLocation) {
        return window.location.origin + lastLocation.pathname;
      } else if (document.referrer !== '') {
        return navigationType();
      }
      return 'Others';
    }
  }

  const handlerSegment = async (streamData) => {
    const liveType = [
      {
        type: '1',
        livestream_type_desc: 'Regular Livestream',
      },
      {
        type: '2',
        livestream_type_desc: 'Private Livestream',
      },
      {
        type: '3',
        livestream_type_desc: 'Game Show',
      },
      {
        type: '5',
        livestream_type_desc: 'ECommerce',
      },
      {
        type: '6',
        livestream_type_desc: 'Spotlight',
      },
    ];
    const livestreamFormat = [
      {
        slot: '1',
        format: 'Regular',
      },
      {
        slot: '2',
        format: 'Audio',
      },
      {
        slot: '101',
        format: 'Video 2-Seat',
      },
      {
        slot: '3',
        format: 'Audio',
      },
      {
        slot: '4',
        format: 'Video 4-Seat',
      },
      {
        slot: '61',
        format: 'Video 6-Seat Layout A',
      },
      {
        slot: '62',
        format: 'Video 6-Seat Layout B',
      },
      {
        slot: '9',
        format: 'Video 9-Seat',
      },
    ];
    if (process.env.REACT_APP_ON_SEGMENT === 'true') {
      const cohostApplied = streamData.response_data.data.data.slots.length > 0;
      let gaming_category = '';
      let game_status = 'false';
      let game_cat = '';
      if (streamData.response_data.data.data.category !== null
        || streamData.response_data.data.data.category !== undefined) {
        gaming_category = streamData.response_data.data.data.category;
      }
      if (streamData.response_data.data.data.is_game === '1' || streamData.response_data.data.data.is_game === 1) {
        game_status = true;
      }
      if (game_status === 'true') {
        game_cat = gaming_category;
      }
      const liveTypeObject = liveType.find((data) => data.type
      === streamData.response_data.data.data.live_type);
      const livestreamFormatObject = livestreamFormat.find((data) => data.slot
      === streamData.response_data.data.data.video);
      window.analytics.track('Livestream Watched', {
        livestream_type: liveTypeObject.livestream_type_desc,
        livestream_format: livestreamFormatObject.format,
        livestream_title: streamData.response_data.data.data.title,
        host_id: streamData.response_data.data.data.liveuser.id.toString(),
        feed_id: streamData.response_data.data.data.channel_id,
        source: sourceTracker(),
        featured: streamData.response_data.data.data.featured,
        cohost_applied: cohostApplied,
        following: streamData.response_data.data.data.relation_status,
        position: 1,
        viewers: parseInt(streamData.response_data.data.data.total_viewer),
        diamonds: parseInt(streamData.response_data.data.data.diamonds),
        gaming_category: game_cat,
        is_gaming_stream: streamData.response_data.data.data.is_game,
      });

      // Insert, Store Host ID and Feed ID in Context
      // To be used by COINS Segment
      setSegmentCoinsContext({
        host_id: streamData.response_data.data.data.liveuser.guid.toString(),
        feed_id: streamData.response_data.data.data.channel_id,
      });
    }
  };

  function trackWatchLivestream(payload) {
    if (typeof window !== 'undefined') {
      import('clevertap-web-sdk').then(({ default: clevertap }) => {
        clevertap.event.push('Watch Livestream', payload);
      });
    }
  }

  function trackWatchEcommLivestream(payload) {
    if (typeof window !== 'undefined') {
      import('clevertap-web-sdk').then(({ default: clevertap }) => {
        clevertap.event.push('Watched E-commerce Live Stream', payload);
      });
    }
  }
  useEffect(() => {
    const triggerSegment = async () => {
      const optionsData = await getUserLivestream(channelId);
      handlerSegment(optionsData);
    };

    // CT event once the user lands on a live regular and ecommerce stream
    const triggerClevertap = async () => {
      const streamData = await getUserLivestream(channelId);
      // 1. Ordinary live broadcast 2: Group live 3: Answer questions 5: E-commerce 6: Spotlight
      const liveType = streamData.response_data.data.data.live_type;
      const hostUid = streamData.response_data.data.data.liveuser.uid;
      const streamTitle = streamData.response_data.data.data.title;
      let payload = {};

      if (streamData.response_data.data.data.type === '1') { // if live - // 0: arriving 1: living 2: end 4: offline
        if (liveType === '5') { // ecommerce stream
          payload = {
            title: streamTitle, // title of stream
            'channel ID': channelId, // channel id
          };

          if (Object.entries(loggedIn).length > 0) { // logged in user
            payload = {
              title: streamTitle, // title of stream
              userId: loggedIn.user_id, // user id of logged in user
              'channel ID': channelId, // channel id
            };
          }
          trackWatchEcommLivestream(payload);
        } else { // regular stream
          payload = {
            'host ID': hostUid, // user id
            title: streamTitle, // title of stream
            'channel ID': channelId, // channel id
          };

          if (Object.entries(loggedIn).length > 0) { // logged in user
            payload = {
              'host ID': hostUid, // user id
              userId: loggedIn.user_id, // user id of logged in user
              title: streamTitle, // title of stream
              'channel ID': channelId, // channel id
            };
          }
          trackWatchLivestream(payload);
        }
      }
    };

    triggerSegment();
    triggerClevertap();
  }, []);
  const updateHostsArray = async (dataCoHosts, _spotlightHosts, _coHosts) => {
    if (dataCoHosts?.spotlightVal) {
      _spotlightHosts = dataCoHosts.spotlightHosts;
    }
  };
  const addInitialCoverImage = async (optionsData) => {
    const remoteUserContainer = document.getElementsByClassName('content-0')[0];
    if (loadingStream === false) {
      if (remoteUserContainer) {
        if (optionsData.slotsTotalNum === '1' || optionsData.slotsTotalNum === '2') {
          remoteUserContainer.style.backgroundImage = `url(${optionsData.cover_image})`;
          remoteUserContainer.style.backgroundSize = 'contain';
        } else {
          remoteUserContainer.style.backgroundImage = `url(${optionsData.avatar})`;
          remoteUserContainer.style.backgroundSize = 'cover';
        }
        remoteUserContainer.style.backgroundRepeat = 'no-repeat';
        remoteUserContainer.style.backgroundPosition = 'center';
        remoteUserContainer.textContent = '';
      }
    }
  };
  // eslint-disable-next-line max-len
  const clientSubscribe = async (mediaType, remoteUsersData, videoSlotsObjectInside, optionsData, coHosts, userInfo, client) => {
    try {
      await client.subscribe(remoteUsersData, mediaType).then(async (promise) => {
        if (promise._userId) {
          try {
            // eslint-disable-next-line max-len
            await publishStream(mediaType, remoteUsersData, videoSlotsObjectInside, optionsData, coHosts, userInfo, client);
          // eslint-disable-next-line no-empty
          } catch (error) {}
        }
      });
    // eslint-disable-next-line no-empty
    } catch (error) {
    }
  };
  const unpublishedVideoHelper = async (
    remoteUsers,
    optionsData,
    videoSlotsObject,
    coHosts,
    userInfo,
  ) => {
    if (remoteUsers.hasVideo === false) {
      await addAvatarBackground(remoteUsers, optionsData, videoSlotsObject, coHosts, userInfo);
    }
  };
  const startBasicLiveStreaming = async (client) => {
    const optionsData = await getUserLivestream(channelId);
    await addInitialCoverImage(optionsData);
    let videoSlots = [];
    const coHosts = [];
    const spotlightHosts = [];
    client.setClientRole('audience');
    // subscribe to a remote user when remote user published a stream
    client.on('user-published', async (...argsData) => {
      const [remoteUsersData, mediaType] = argsData;
      const videoSlotsObjectInside = await getVideoSlotsData(channelId);
      let userInfo = null;
      if (video !== '3') {
        userInfo = await getUserInfoData(remoteUsersData.uid, channelId);
      }
      // eslint-disable-next-line max-len
      await clientSubscribe(mediaType, remoteUsersData, videoSlotsObjectInside, optionsData, coHosts, userInfo, client);
    });
    // when remote user ended the stream or unpublished it
    client.on('user-unpublished', async (...args) => {
      const [remoteUsers, mediaType] = args;
      const videoSlotsObject = await getVideoSlotsData(channelId);
      const userInfo = await getUserInfoData(remoteUsers.uid, channelId);
      if (mediaType === 'video') {
        // put all the behavior of the user here if the streamer turn off the cam
        await unpublishedVideoHelper(remoteUsers, optionsData, videoSlotsObject, coHosts, userInfo);
      } else if (mediaType === 'audio') {
        // put all the behavior of the user here if the streamer muted the mic
        setRemoteUsersObject((prev) => prev.filter((user) => user.uid !== remoteUsers.uid));
      } else {
        const remoteUserContainer = document.getElementById(remoteUsers.uid);
        remoteUserContainer.remove();
      }
    });
    // method to detect if there are new user join the channel as host
    client.on('user-joined', async (...args) => {
      const [remoteUsers] = args;
      const videoSlotsObject = await getVideoSlotsData(channelId);
      if (video !== '3') {
        const userInfo = await getUserInfoData(remoteUsers.uid, channelId);
        videoSlots = videoSlotsObject;
        setCohost((prev) => [...prev, remoteUsers]);
        await addUserJoinedBackground(
          remoteUsers,
          optionsData,
          videoSlotsObject,
          coHosts,
          userInfo,
          spotlightHosts,
        );
      }
    });
    // method to detect if there are new user join the channel as host
    client.on('user-left', async (...args) => {
      const [remoteUsers] = args;
      await getVideoSlotsData(channelId);
      await livestreamEndedAudio(remoteUsers, optionsData);
      if (video !== '3') {
        const profileContainer = document.getElementById(`profile-${remoteUsers.uid}`);
        profileContainer && profileContainer.remove();
        const dataCoHosts = await removeCohostContainer(
          optionsData,
          remoteUsers,
          coHosts,
          videoSlots,
          spotlightHosts,
        );
        await updateHostsArray(dataCoHosts, spotlightHosts, coHosts);
      }
    });
    if (optionsData.channelIdVal) {
      if (Object.entries(loggedIn).length > 0) {
        // working at 3 seconds
        const userIdVal = loggedIn.user_id + 1000000000;
        await client.setClientRole('audience');
        await client.join(
          optionsData.agoraAppId,
          optionsData.channelIdVal,
          optionsData.channelKey,
          userIdVal,
        );
      } else {
        await client.leave();
        await client.join(
          optionsData.agoraAppId,
          optionsData.channelIdVal,
          optionsData.channelKey,
          0,
        );
      }
    }
  };
  useEffect(() => {
    // Initialize Agora RTC client using dynamic imports
    let client = '';
    const importAgora = async () => {
      await import('agora-rtc-sdk-ng').then(({ default: agora }) => {
        agora.setLogLevel(4);
        client = agora.createClient({
          mode: 'live',
          codec: 'h264',
        });
      });
    };
    setShowMuteBtn(true);
    mute();
    const audioCtx = new AudioContext();
    if (audioCtx.state === 'running') {
      audioCtx.suspend();
    }
    const loadStream = async () => {
      await importAgora();
      Cookies.set('muteState', true);
      await startStream(client);
    };
    loadStream();

    return function cleanUp() {
      client.leave();
      Cookies.remove('muteState');
    };
  }, [channelId, loggedIn]);

  /// / ------------------------ End of profile components here ---------------------

  // Volume Controls Function and Volume Components ---------
  // Volume Controls Function and Volume Components ---------
  const alterVolume = async (_event, newVolume) => {
    setVolume(newVolume);
    if (muteState === false) {
      for (const user of remoteUsersObject) {
        user.remoteAudioTrack.setVolume(newVolume);
      }
    } else {
      setLastVolume(newVolume);
    }
  };
  const mute = () => {
    if (muteState === false) {
      setMuteState(true);
      Cookies.set('muteState', true);
      setLastVolume(volume);
      alterVolume('volume', 0);
      setVolume(0);
    }
  };
  const unmute = () => {
    if (muteState) {
      setMuteState(false);
      const audioCtx = new AudioContext();
      if (audioCtx.state === 'suspended') {
        audioCtx.resume();
      }
      setShowMuteBtn(false);
      Cookies.set('muteState', false);
      setVolume(lastVolume);
      for (const user of remoteUsersObject) {
        user.remoteAudioTrack.setVolume(lastVolume);
      }
    }
  };

  // Full Screen Controls Function and Component
  const getClass = async () => streamLayouts.find((object) => object.slotsTotalNum === slotsTotal);
  const exitHandler = async () => {
    if (!document.fullscreenElement
      && !document.webkitIsFullScreen
      && !document.mozFullScreen
      && !document.msFullscreenElement) {
      const classValueExit = await getClass();
      if (classValueExit) {
        const videoContainerExit = document.getElementsByClassName(classValueExit.mainClass)[0];
        videoContainerExit.classList.remove(classValueExit.className);
        setIsFullScreen(false);
      }
      document.removeEventListener('fullscreenchange', exitHandler);
      document.removeEventListener('webkitfullscreenchange', exitHandler);
      document.removeEventListener('mozfullscreenchange', exitHandler);
      document.removeEventListener('MSFullscreenChange', exitHandler);
    }
  };

  document.addEventListener('fullscreenchange', exitHandler);
  document.addEventListener('webkitfullscreenchange', exitHandler);
  document.addEventListener('mozfullscreenchange', exitHandler);
  document.addEventListener('MSFullscreenChange', exitHandler);
  const renderFullScreen = () => {
    const streamContainer = document.getElementById('stream-container');
    const classValue = streamLayouts.find((object) => object.slotsTotalNum === slotsTotal);
    const videoContainer = document.getElementsByClassName(classValue.mainClass)[0];
    if (document.fullscreenElement) {
      setIsFullScreen(false);
      document.exitFullscreen();
      videoContainer.classList.remove(classValue.className);
    } else if (document.webkitIsFullScreen) {
      setIsFullScreen(false);
      document.webkitExitFullscreen();
      document.webkitCancelFullScreen();
      videoContainer.classList.remove(classValue.className);
    } else if (streamContainer.requestFullscreen) {
      videoContainer.classList.add(classValue.className);
      setIsFullScreen(true);
      streamContainer.requestFullscreen();
    } else if (streamContainer.webkitRequestFullscreen) { /* Safari */
      videoContainer.classList.add(classValue.className);
      setIsFullScreen(true);
      streamContainer.webkitRequestFullscreen();
    } else if (streamContainer.msRequestFullscreen) { /* IE11 */
      videoContainer.classList.add(classValue.className);
      setIsFullScreen(true);
      streamContainer.msRequestFullscreen();
    } else if (streamContainer.webkitEnterFullscreen) {
      videoContainer.classList.add(classValue.className);
      streamContainer.webkitEnterFullscreen();
      setIsFullScreen(true);
    } else if (streamContainer.mozRequestFullScreen) {
      setIsFullScreen(true);
      videoContainer.classList.add(classValue.className);
      streamContainer.msRequestFullscreen();
    }
  };

  // Share button functions and component
  const [copyLink, setCopyLink] = useState('');
  const [modalStatus, setModalStatus] = useState(false);
  const popUpMsg = 'Copied!';
  const [anchorEl, setAnchorEl] = useState(null);
  const appLink = useRef('');
  const popOverOpen = Boolean(anchorEl);
  const popOver = popOverOpen ? 'simple-popover' : undefined;
  const branchKey = process.env.REACT_APP_BRANCH_KEY;
  // modal styles
  const modalClasses = useStyles();
  const copyAppLinkStream = (event) => {
    appLink.current.select();
    // copy the link when user touch input field
    navigator.clipboard.writeText(appLink.current.value);
    setAnchorEl(event.currentTarget);
    setTimeout(() => {
      setAnchorEl(null);
    }, 3000);
  };
  const closePopUp = () => {
    setAnchorEl(null);
  };
  // opening the share modal with the copy link input
  const handleOpen = () => {
    // load
    const options = {};

    let hostUrlKumuLiveFirst = 'https://kumu.live/';
    if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
      hostUrlKumuLiveFirst = 'https://dev.kumu.live/';
    } else if (process.env.REACT_APP_ENVIRONMENT === 'stg') {
      hostUrlKumuLiveFirst = 'https://stg.kumu.live/';
    }

    let desktopUrl = hostUrlKumuLiveFirst + userData.username;
    let branchType = '5';
    if (campaignId) {
      desktopUrl = `${hostUrlKumuLiveFirst + userData.username}/campaign`;
      branchType = '6';
    }

    let sharer_id_val;
    if (loggedIn.length <= 0) {
      sharer_id_val = 'no_id';
    } else {
      sharer_id_val = loggedIn.guid;
    }
    // initialize branch using dynamic imports
    import('branch-sdk').then(({ default: branchModule }) => {
      branchModule.init(branchKey, options, () => {
        if (campaignId) {
          // campaign link
          branchModule.link({
            feature: 'share',
            tags: ['desktop_creator'],
            data: {
              type: branchType,
              user_id: channelId,
              channel_id: channelId,
              userId: channelId,
              source_from: 'campaign',
              public_group_id: null,
              userName: userData.username,
              $og_title: title,
              $og_image_url: coverImage,
              $desktop_url: desktopUrl,
              shared_id: userData.uid,
              sharer_id: sharer_id_val,
            },
          }, (_error, link) => {
            setCopyLink(link);
          });
        } else {
          // non-campaign link
          branchModule.link({
            feature: 'share',
            tags: ['desktop_creator'],
            data: {
              type: branchType,
              user_id: channelId,
              channel_id: channelId,
              userId: channelId,
              $og_title: 'Live on Kumu!',
              $og_image_url: coverImage,
              $desktop_url: desktopUrl,
              shared_id: userData.uid,
              sharer_id: sharer_id_val,
            },
          }, (_error, link) => {
            setCopyLink(link);
          });
        }
      });
    });

    setModalStatus(true);
  };

  const [startTime, setStartTime] = useState('');

  useEffect(() => {
    setStartTime(moment().format('YYYY/MM/DD HH:mm:ss'));
  }, []);

  const handleClose = () => {
    setModalStatus(false);
  };
  const callbackWhatsAppAccount = (newlink) => {
    const newWin = window.open(newlink);
    if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
      Swal.fire({
        icon: 'info',
        title: 'Oops...',
        text: 'We noticed that your pop-ups are being blocked. Kindly enable browser pop-ups in your settings and try again.',
      });
    }
  };

  const sharedDuration = () => {
    const endTimeDuration = moment().format('YYYY/MM/DD HH:mm:ss');
    const sharedWatchDuration = moment.duration(moment(endTimeDuration)
      .diff(moment(startTime))).asSeconds();
    const shareDurationTimer = setInterval(sharedWatchDuration, 1000);
    clearInterval(shareDurationTimer);
    return sharedWatchDuration;
  };

  const shareToSocialMediaAccounts = async (socmedTypeObj, _err, link) => {
    const streamData = await getUserLivestream(channelId);
    const isStreamFollowing = () => relation_status === 5 || relation_status === 1;
    const isStreamFeatured = () => type === 1;
    if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      const newWin = window.open(socmedTypeObj.mobile_new_link);
      if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
        Swal.fire({
          icon: 'info',
          title: 'Oops...',
          text: 'We noticed that your pop-ups are being blocked. Kindly enable browser pop-ups in your settings and try again.',
        });
      }
    } else if (socmedTypeObj.socmedType === 'messenger' || socmedTypeObj.socmedType === 'facebook') {
      const fbId = process.env.REACT_APP_FACEBOOK_APP_ID;
      const popupWinWidth = 400;
      const popupWinHeight = 500;
      // eslint-disable-next-line no-restricted-globals
      const popupWinLeft = (screen.width - popupWinWidth) / 2;
      // eslint-disable-next-line no-restricted-globals
      const popupWinTop = (screen.height - popupWinHeight) / 4;
      let shareLink;

      if (socmedTypeObj.socmedType === 'facebook') {
        shareLink = `https://www.facebook.com/dialog/${socmedTypeObj.method}?app_id=${fbId}&display=popup&href=${link}`;
      } else if (socmedTypeObj.socmedType === 'messenger') {
        shareLink = `https://www.facebook.com/dialog/${socmedTypeObj.method}?app_id=${fbId}&display=popup&link=${link}&redirect_uri=${process.env.REACT_APP_KL2_URL}`;
      }
      const newWin = window.open(shareLink, 'popUpWindow', `height=${popupWinHeight},width=${popupWinWidth},left=${popupWinLeft},top=${popupWinTop},resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes`);
      if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
        Swal.fire({
          icon: 'info',
          title: 'Oops...',
          text: 'We noticed that your pop-ups are being blocked. Kindly enable browser pop-ups in your settings and try again.',
        });
      }
    } else if (socmedTypeObj.socmedType === 'whatsapp' && socmedTypeObj.desktop_new_link) {
      callbackWhatsAppAccount(socmedTypeObj.desktop_new_link);
    }
    window.analytics.track('Livestream Shared', {
      duration: sharedDuration(),
      host_id: streamData.response_data.data.data.liveuser.guid.toString(),
      feed_id: streamData.response_data.data.data.channel_id,
      source: sourceTracker(),
      shared_destination: socmedTypeObj.socmedType,
      share_link_generated: copyLink,
      featured: isStreamFeatured(),
      following: isStreamFollowing(),
      tags: streamData.response_data.data.data.category,
    });
  };
  const shareStream = (socmed) => {
    const options = {};

    let hostUrlKumuLiveFirst = 'https://kumu.live/';
    if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
      hostUrlKumuLiveFirst = 'https://dev.kumu.live/';
    } else if (process.env.REACT_APP_ENVIRONMENT === 'stg') {
      hostUrlKumuLiveFirst = 'https://stg.kumu.live/';
    }

    let desktopUrl = hostUrlKumuLiveFirst + userData.username;
    if (campaignId) {
      desktopUrl = `${hostUrlKumuLiveFirst + userData.username}/campaign`;
    }
    // Initialized and used branch using dynamic imports
    import('branch-sdk').then(({ default: branchModule }) => {
      branchModule.init(branchKey, options, () => {
        branchModule.link({
          channel: socmed,
          feature: 'share',
          tags: ['desktop_creator'],
          data: {
            type: '5',
            user_id: channelId,
            $og_title: 'Live on Kumu!',
            $og_image_url: coverImage,
            $desktop_url: desktopUrl,
          },
        }, (error, link) => {
          const socmedTypesStream = [
            {
              socmedType: 'facebook',
              mobile_new_link: `https://www.facebook.com/dialog/share?app_id=1983914755180097&display=popup&href=${link}&redirect_uri=${desktopUrl}`,
              method: 'share',
              desktop_new_link: '',
            },
            {
              socmedType: 'messenger',
              mobile_new_link: `fb-messenger://share?link=${link}`,
              method: 'send',
              desktop_new_link: '',
            },
            {
              socmedType: 'whatsapp',
              mobile_new_link: `whatsapp://send?text=${link}`,
              method: 'redirect',
              desktop_new_link: `https://web.whatsapp.com/send?text=${link}`,
            },
          ];
          const socmedTypeFound = socmedTypesStream.find((obj) => obj.socmedType === socmed);
          if (socmedTypeFound) {
            shareToSocialMediaAccounts(socmedTypeFound, error, link);
          }
        });
      });
    });
  };

  const renderShareModal = () => (
    <div className={modalClasses.paper}>
      <Grid container className='shareModal-head'>
        <Grid item>
          <h2 className='share-title' style={{ marginTop: 10 }}>Share Stream</h2>
        </Grid>
        <Grid>
          <IconButton onClick={handleClose}>
            <Close className='close-modal-share'>X</Close>
          </IconButton>
        </Grid>
      </Grid>
      <Grid container className='shareModal-body-share' justifyContent='space-between' alignItems='center'>
        <Grid item lg={4} md={4} sm={4}>
          <Button onClick={() => { shareStream('messenger'); }} id='messenger'><img alt='messenger_logo' src={messenger} /></Button>
        </Grid>
        <Grid item lg={4} md={4} sm={4}>
          <Button onClick={() => { shareStream('facebook'); }} id='facebook'><img alt='facebook_logo' src={facebook} /></Button>
        </Grid>
        <Grid item lg={4} md={4} sm={4}>
          <Button onClick={() => { shareStream('whatsapp'); }} id='whatsapp'><img alt='whatsapp_logo' src={whatsapp} /></Button>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Typography>Copy Link</Typography>
          <input type='text' value={copyLink} ref={appLink} onClick={copyAppLinkStream} className='copy-link-input' readOnly />
          <Popover
            id={popOver}
            open={popOverOpen}
            anchorEl={anchorEl}
            onClose={closePopUp}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <Typography>{popUpMsg}</Typography>
          </Popover>
        </Grid>
      </Grid>
    </div>
  );
  // muteState, unmute, mute, volume, alterVolume, renderFullScreen, handleOpen

  const layoutObjects = [
    {
      slotTotal: '1',
      slotComponent: <OneSlot
        landscape={landscape}
        muteState={muteState}
        unmute={unmute}
        mute={mute}
        volume={volume}
        alterVolume={alterVolume}
        renderFullScreen={renderFullScreen}
        handleOpen={handleOpen}
        isFullScreen={isFullScreen}
        showMuteBtn={showMuteBtn}
        resumeAudioContext={resumeAudioContext}
        rtmp={rtmp}
        isOfflineCampaignStream={props.offlineCampaignStream}
        isCampaignPage={props.isCampaignPage}
      />,
    },
    {
      slotTotal: '2',
      slotComponent: <OneSlot
        landscape={landscape}
        muteState={muteState}
        unmute={unmute}
        mute={mute}
        volume={volume}
        alterVolume={alterVolume}
        renderFullScreen={renderFullScreen}
        handleOpen={handleOpen}
        isFullScreen={isFullScreen}
        showMuteBtn={showMuteBtn}
        resumeAudioContext={resumeAudioContext}
        rtmp={rtmp}
        isOfflineCampaignStream={props.offlineCampaignStream}
        isCampaignPage={props.isCampaignPage}
      />,
    },
    {
      slotTotal: '3',
      slotComponent: <AudioStream
        landscape={landscape}
        muteState={muteState}
        unmute={unmute}
        mute={mute}
        volume={volume}
        alterVolume={alterVolume}
        renderFullScreen={renderFullScreen}
        handleOpen={handleOpen}
        isFullScreen={isFullScreen}
        showMuteBtn={showMuteBtn}
        resumeAudioContext={resumeAudioContext}
        isOfflineCampaignStream={props.offlineCampaignStream}
        isCampaignPage={props.isCampaignPage}
      />,
    },
    {
      slotTotal: '101',
      slotComponent: <TwoSlots
        muteState={muteState}
        unmute={unmute}
        mute={mute}
        volume={volume}
        alterVolume={alterVolume}
        renderFullScreen={renderFullScreen}
        handleOpen={handleOpen}
        isFullScreen={isFullScreen}
        showMuteBtn={showMuteBtn}
        resumeAudioContext={resumeAudioContext}
        isOfflineCampaignStream={props.offlineCampaignStream}
        isCampaignPage={props.isCampaignPage}
      />,
    },
    {
      slotTotal: '4',
      slotComponent: <FourSlots
        muteState={muteState}
        unmute={unmute}
        mute={mute}
        volume={volume}
        alterVolume={alterVolume}
        renderFullScreen={renderFullScreen}
        handleOpen={handleOpen}
        isFullScreen={isFullScreen}
        showMuteBtn={showMuteBtn}
        resumeAudioContext={resumeAudioContext}
        isOfflineCampaignStream={props.offlineCampaignStream}
        isCampaignPage={props.isCampaignPage}
      />,
    },
    {
      slotTotal: '61',
      slotComponent: <FirstSixSlots
        muteState={muteState}
        unmute={unmute}
        mute={mute}
        volume={volume}
        alterVolume={alterVolume}
        renderFullScreen={renderFullScreen}
        handleOpen={handleOpen}
        isFullScreen={isFullScreen}
        showMuteBtn={showMuteBtn}
        resumeAudioContext={resumeAudioContext}
        isOfflineCampaignStream={props.offlineCampaignStream}
        isCampaignPage={props.isCampaignPage}
      />,
    },
    {
      slotTotal: '62',
      slotComponent: <SecondSixSlots
        muteState={muteState}
        unmute={unmute}
        mute={mute}
        volume={volume}
        alterVolume={alterVolume}
        renderFullScreen={renderFullScreen}
        handleOpen={handleOpen}
        isFullScreen={isFullScreen}
        showMuteBtn={showMuteBtn}
        resumeAudioContext={resumeAudioContext}
        isOfflineCampaignStream={props.offlineCampaignStream}
        isCampaignPage={props.isCampaignPage}
      />,
    },
    {
      slotTotal: '9',
      slotComponent: <NineSlots
        muteState={muteState}
        unmute={unmute}
        mute={mute}
        volume={volume}
        alterVolume={alterVolume}
        renderFullScreen={renderFullScreen}
        handleOpen={handleOpen}
        isFullScreen={isFullScreen}
        showMuteBtn={showMuteBtn}
        resumeAudioContext={resumeAudioContext}
        isOfflineCampaignStream={props.offlineCampaignStream}
        isCampaignPage={props.isCampaignPage}
      />,
    },
  ];

  const renderLayout = () => {
    if (isLiveStreamEnded) {
      return <VideoStreamEnded />;
    }
    if (loadingStream === false) {
      if (slotsTotal) {
        return layoutObjects?.find((object) => object.slotTotal === slotsTotal).slotComponent;
      }
    }
  };

  return (
    <>
      {
        loadingStream
          ? <LoadingIndicator />
          : (
            <>
              <div className='video-layout'>
                {renderLayout()}
              </div>
              <Modal
                className={modalClasses.modal}
                open={modalStatus}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={modalStatus}>
                  {renderShareModal()}
                </Fade>
              </Modal>
            </>
          )
      }
    </>
  );
}
export default VideoStream;
